import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { db } from '../../db/db';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-admin-import',
    templateUrl: './admin-import.component.html',
    styleUrls: ['./admin-import.component.scss']
})
export class AdminImportComponent implements OnInit {

    Files: File[] = [];
    Accept: string;

    constructor(private dialog: MatDialog) { }

    ngOnInit(): void {
    }

    onFileChangeDB(event: any) {

        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }

        let fileReader = new FileReader();
        fileReader.onload = (e) => {
            db.importDB(e.target.result)
        }

        fileReader.readAsText(this.Files[0]);   
        
    }

    onFileChangeLocalStorage(event: any) {

        let files = event instanceof FileList ? event : event.files;

        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.Files.push(element);
        }

        let fileReader = new FileReader();
        fileReader.onload = (e) => {

            localStorage.clear();
            var data = JSON.parse(e.target.result as string);
            Object.keys(data).forEach(function (k) {
                localStorage.setItem(k, JSON.stringify(data[k]));
            });
        }

        fileReader.readAsText(this.Files[0]);       
    }
}

export enum EImportType {
    IndexedDB,
    LocalStorage
}